import { z } from "zod";

import { branded } from "@/lib/helpers/branded-helper";

export const missionDtoSchema = z.object({
  id: branded.missionId,
  note: z.string(),
  description: z.string(),
});

export type TMissionDto = z.infer<typeof missionDtoSchema>;
